import React from 'react';
import { Box, Snackbar } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'keys';
import { useDispatch } from 'react-redux';
import { actions } from 'store';

const PositionedSnackbar = () => {
    const { snackbars } = useSelector(state => state.general)
    const dispatch = useDispatch()

    const closeSnackbar = (type) => {
        dispatch(actions.setSnackbars({ type: type, open: false }))
    }

    return (
        <Box sx={{ width: 500 }}>
            {snackbars[toast.createAssessment].open &&
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    open={true}
                    autoHideDuration={4000}
                    onClose={() => closeSnackbar(toast.createAssessment)}
                    message={"נשמר בהצלחה"}
                />
            }
        </Box>
    );
}

export default PositionedSnackbar